import React from 'react';

import { BaseLinkPanelTags } from '../LinkPanelTypes';

type Props = {
    className?: string;
    tags?: BaseLinkPanelTags;
};

const Tags: React.FC<Props> = ({ className = 'sgw-link-panel__labels', tags }) =>
    tags ? <span className={className}>{tags}</span> : null;

export default Tags;
